import { faEllipsisH, faStar } from "@fortawesome/pro-regular-svg-icons";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
import styled from "styled-components";

import { Menu, Dropdown } from "antd";

export function FilterBarMenu(props) {
    const changeFilterBarMode = (newMode) => () => { props.changeFilterBarMode(newMode); };
    const openModal = (action) => () => { props.openModal(action); };
    
    const getFilterMenuItems = () => {
        const menuItems = [];
        const hasQ = props.qualifiers.toString().length > 0;
        
        if (hasQ) {
            menuItems.push(
                <Menu.Item key="new-filters" className="menu-item active">
                    <div className="menu-icon"><FontAwesomeIcon icon={faStar} size="1x" /></div>
                    <div className="menu-lbl" onClick={openModal("new")}>Save to favorites</div>
                </Menu.Item>
            );
        } else {
            menuItems.push(<Menu.Item disabled key="new-filters" className="menu-item"><div className="menu-icon"><FontAwesomeIcon icon={faStar} size="1x" /></div><div className="menu-lbl">Save to favorites</div></Menu.Item>);
        }
        // if (props.savedFilter) {
        //     menuItems.push(<Menu.Item key="copy-filters" className="menu-item active"><div className="menu-icon"><FontAwesomeIcon icon={faClone} size="1x" /></div><div className="menu-lbl" onClick={openModal("copy")}>Copy filters</div></Menu.Item>);
        // } else {
        //     menuItems.push(<Menu.Item disabled key="copy-filters" className="menu-item"><div className="menu-icon"><FontAwesomeIcon icon={faClone} size="1x" /></div><div className="menu-lbl">Copy filters</div></Menu.Item>);
        // }
        // if (hasQ) {
        //     menuItems.push(<Menu.Item key="edit-filters" className="menu-item active"><div className="menu-icon"><FontAwesomeIcon icon={faEdit} size="1x" /></div><div className="menu-lbl" onClick={openModal("edit")}>Edit filters</div></Menu.Item>);
        // } else {
        //     menuItems.push(<Menu.Item disabled key="edit-filters" className="menu-item"><div className="menu-icon"><FontAwesomeIcon icon={faEdit} size="1x" /></div><div className="menu-lbl">Edit filters</div></Menu.Item>);
        // }
        return menuItems;
    };
    
    const menu = () => (
        <Menu>
            {getFilterMenuItems()}
            <Menu.Divider/>
            <Menu.ItemGroup title="Filter bar view" className="category-group">
                <Menu.Item className={classnames("menu-item", { active: props.mode === "token" })} onClick={changeFilterBarMode("token")}>
                    <div className="menu-icon"><FontAwesomeIcon className="indicator" icon={faCircle}/></div>
                    <div className="menu-lbl">Tokens</div>
                </Menu.Item>
                <Menu.Item className={classnames("menu-item", { active: props.mode === "categories" }, { hidden: props.categoryModeOn === false })} onClick={changeFilterBarMode("categories")}>
                    <div className="menu-icon"><FontAwesomeIcon className="indicator" icon={faCircle}/></div>
                    <div className="menu-lbl">Categories</div>
                </Menu.Item>
                <Menu.Item className={classnames("menu-item", { active: props.mode === "text" })} onClick={changeFilterBarMode("text")}>
                    <div className="menu-icon"><FontAwesomeIcon className="indicator" icon={faCircle}/></div>
                    <div className="menu-lbl">Markup</div>
                </Menu.Item>
            </Menu.ItemGroup>
        </Menu>
    );
        
    return (
        <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]} getPopupContainer={(trigger) => trigger}>
            <CategoryMenuBtn><FontAwesomeIcon icon={faEllipsisH} size="1x" /></CategoryMenuBtn>
        </Dropdown>
    );
}

const CategoryMenuBtn = styled.div`
    width: 38px;
    height: 38px;
    text-align: center;
    padding-top: 9px;
    cursor: pointer;
    .ant-dropdown-menu {
        width: 280px;

        ul {
            margin: 0;
        }

        .ant-dropdown-menu-title-content {
            display: flex;
            flex-direction: row;
        }

        .menu-item {
            display: flex;
            flex-direction: row;
            text-align: left;
            line-height: 30px;
            font-size: ${(props) => props.theme.fontSizeLarge};
          
            .menu-icon {
                padding: 0 5px;

                .indicator {
                    visibility: hidden;
                    color: ${(props) => props.theme.colors["green-leaf"]};
                    padding-left: 6px;
                    padding-top: 3px;
                    width: 12px;
                }
            }
            
            .menu-lbl {
                color: ${(props) => props.theme.colors["gray-dark"]};
            }
        }

        .menu-item.active {
            .indicator {
                visibility: visible;
            }
        }
    }
`;
